import { Box, HStack, Text } from '@chakra-ui/react'

/** A section divider with an uppercase caption (and optional trailing note). */
const SectionHeading = ({
  label,
  note,
}: {
  /** Section caption. */
  label: string
  /** Optional trailing note (e.g. "optional"). */
  note?: string
}) => (
  <HStack gap="9px" mt="26px" mb="14px">
    <Text fontSize="12px" fontWeight="bold" letterSpacing="0.06em" textTransform="uppercase" color="gray.500">
      {label}
    </Text>
    {note && (
      <Text fontSize="11px" fontWeight="medium" color="gray.400">
        {note}
      </Text>
    )}
    <Box flex="1" h="1px" bg="gray.100" />
  </HStack>
)

export default SectionHeading
